import React, { PropTypes } from 'react';
import { List } from 'material-ui/List';
import MenuItem from 'material-ui/MenuItem';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import ConfirmMessage from '../../ConfirmMessage';
import style from './style';
import { Link } from 'react-router';
import { iconFactory } from '../../Icons';
import IconSignOut from '../../Icons/IconSignOut';

const EXTERNAL_URL_REGEXP = /^http/;

class NavigationBar extends React.Component {
  static propTypes = {
    onSelectItem: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    manageSettings: PropTypes.bool.isRequired,
    manageManagers: PropTypes.bool.isRequired,
    user: PropTypes.shape({
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired
    })
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    muiTheme: PropTypes.object.isRequired
  };

  constructor(props, context) {
    super(props, context);

    const { navBar } = context.muiTheme;

    this.navBarTheme = getMuiTheme({
      palette: {
        textColor: navBar.color,
        canvasColor: navBar.backgroundColor
      }
    });

    this.style = {
      root: {
        backgroundColor: navBar.backgroundColor
      },
      logoContainer: {
        minHeight: 139,
        padding: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        color: navBar.color,
        flexShrink: 1,
        flexGrow: 1,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${navBar.BGImage})`,
        backgroundColor: navBar.backgroundColor,
        boxSizing: 'border-box'
      },
      userNameBlock: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        maxWidth: '100%'
      },

      userName: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      },

      signOutIcon: {
        height: 16,
        width: 16,
        flex: '0 0 auto',
        position: 'relative',
        cursor: 'pointer',
        top: '4px',
        verticalAlign: 'top',
        marginLeft: '15px'
      }
    };

    this.logo = navBar.logo
      ? React.createElement(navBar.logo, {
          style: {
            width: 'auto',
            maxWidth: 112,
            height: 85
          }
        })
      : null;
  }

  state = {
    open: false
  };

  close() {
    this.setState({ open: false });
  }

  confirm = () => {
    this.setState({ open: true });
  };

  render() {
    let { user, clubSettings, logout } = this.props;
    let { first_name, last_name, email } = user || {};

    const { navBar } = this.context.muiTheme;
    const urlToServiceDesk = 'mailto:sam@liveapps.ch';

    return (
      <MuiThemeProvider muiTheme={this.navBarTheme}>
        <div style={this.style.root}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <div style={this.style.logoContainer}>{this.logo}</div>
            <div
              style={{
                padding: '0 16px 16px',
                color: navBar.color
              }}
            >
              <div style={this.style.userNameBlock}>
                <strong style={this.style.userName}>
                  {first_name} {last_name}
                </strong>
                <IconSignOut
                  color={navBar.iconColor}
                  onClick={this.confirm}
                  style={this.style.signOutIcon}
                />
              </div>
              <div style={{ display: 'block', lineHeight: 1 }}>
                <small>{email}</small>
              </div>
            </div>
          </div>
          <List
            className={style.nav}
            style={{ backgroundColor: 'transparent' }}
          >
            {/*<Divider/>*/}
            {this.renderModuleList(clubSettings.modules)}
            <MenuItem
              primaryText={'Need Help?'}
              href={urlToServiceDesk}
              target="_blank"
              style={{ color: navBar.color }}
            />
          </List>
          <ConfirmMessage
            open={this.state.open}
            label={'Are you sure you want to log out?'}
            onConfirm={logout}
            onClose={() => this.close()}
          />
        </div>
      </MuiThemeProvider>
    );
  }

  renderModuleList(list) {
    let { user } = this.props;
    if (user)
      return list
        .filter(({ access }) => access.indexOf(user.userRole) !== -1)
        .map(this.renderListItem);
  }

  renderListItem = (item, index) => {
    let { onSelectItem } = this.props;

    let {
      muiTheme: { navBar },
      router
    } = this.context;

    if (item.children) {
      return (
        <MenuItem
          key={index}
          leftIcon={this.renderMenuIcon(item.icon)}
          primaryText={item.name}
          menuItems={this.renderModuleList(item.children)}
        />
      );
    } else {
      let menuItemStyle = {
        backgroundColor:
          item.external !== true && router.isActive(item.link)
            ? navBar.activeBackgroundColor
            : null
      };
      let menuItem = (
        <MenuItem
          key={index}
          style={menuItemStyle}
          leftIcon={this.renderMenuIcon(item.icon)}
          primaryText={item.name}
        />
      );
      return !EXTERNAL_URL_REGEXP.test(item.link) ? (
        <Link
          to={item.link}
          className={style.link}
          activeClassName={style.active}
          key={index}
          onClick={onSelectItem}
        >
          {menuItem}
        </Link>
      ) : (
        <a
          key={index}
          href={item.link}
          className={style.link}
          onClick={onSelectItem}
          target={item.target ? item.target : false}
        >
          {menuItem}
        </a>
      );
    }
  };

  renderMenuIcon(name) {
    let { navBar } = this.context.muiTheme;

    let iconParams = {
      color: navBar.iconColor,
      style: {
        width: 36,
        height: 36,
        margin: '7px 12px'
      }
    };

    return React.createElement(iconFactory(name), iconParams);
  }
}

NavigationBar.defaultProps = {
  manageSettings: false,
  manageManagers: false,
  user: {}
};

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/components/LoggedLayout/NavigationBar/NavigationBar.jsx